/* krafd theme scripts - alles via de Shopify Cart API, geen browseropslag */
(function () {
  var cfg = window.krafd || {};
  var FREE = (cfg.freeShipping || 0) * 100;
  function money(c) { return '€ ' + (c / 100).toFixed(2).replace('.', ','); }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  window.openMenu = function () {
    var m = document.getElementById('mmenu'); if (!m) return;
    m.classList.add('on'); m.setAttribute('aria-hidden', 'false');
    document.getElementById('mscrim').classList.add('on');
    document.body.style.overflow = 'hidden';
    var b = m.querySelector('button'); if (b) b.focus();
  };
  window.closeMenu = function () {
    var m = document.getElementById('mmenu'); if (!m) return;
    m.classList.remove('on'); m.setAttribute('aria-hidden', 'true');
    document.getElementById('mscrim').classList.remove('on');
    document.body.style.overflow = '';
  };

  var lastFocus = null;
  window.openCart = function () {
    var d = document.getElementById('drawer'); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('on'); d.setAttribute('aria-hidden', 'false');
    document.getElementById('scrim').classList.add('on');
    document.body.style.overflow = 'hidden';
    var c = d.querySelector('.dr-close'); if (c) c.focus();
  };
  window.closeCart = function () {
    var d = document.getElementById('drawer'); if (!d) return;
    d.classList.remove('on'); d.setAttribute('aria-hidden', 'true');
    document.getElementById('scrim').classList.remove('on');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { window.closeCart(); window.closeMenu(); }
  });

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  window.cartAdd = function (id, qty, plan) {
    var item = { id: id, quantity: qty || 1 };
    if (plan) item.selling_plan = plan;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) { return r.json(); }).then(function () { return render(true); });
  };

  window.cartChange = function (key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return cart; }
      return render(false);
    });
  };

  // Labels bij een regel. Alles hieronder komt uit de winkelwagen zelf: een prijs van
  // nul, of een korting die Shopify daadwerkelijk heeft toegepast. Nooit iets verzinnen —
  // wat hier staat moet ook op de afrekenpagina terugkomen.
  function labels(item) {
    var uit = [];
    if (item.final_line_price === 0) uit.push({ t: 'Gratis', v: 'gift' });
    var kortingen = item.line_level_discount_allocations || [];
    for (var i = 0; i < kortingen.length; i++) {
      var d = kortingen[i].discount_application;
      if (d && d.title) uit.push({ t: d.title, v: 'deal' });
    }
    if (!kortingen.length && item.original_line_price > item.final_line_price) {
      uit.push({ t: 'Korting', v: 'deal' });
    }
    if (!uit.length) return '';
    return '<div class="mrk">' + uit.map(function (m) {
      return '<span class="mrk-t mrk-' + m.v + '">' + esc(m.t) + '</span>';
    }).join('') + '</div>';
  }

  function lineHtml(item) {
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" loading="lazy" width="40">'
      : '<span class="mono">KRAFD</span>';
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="var">' + esc(item.variant_title) + '</div>' : '';
    var plan = item.selling_plan_allocation
      ? '<div class="abo">' + esc(item.selling_plan_allocation.selling_plan.name) + '</div>' : '';
    var old = item.original_line_price > item.final_line_price
      ? '<span class="old">' + money(item.original_line_price) + '</span>' : '';
    return '<div class="line">' +
      '<div class="art">' + img + '</div>' +
      '<div><div class="nm"><a href="' + item.url + '">' + esc(item.product_title) + '</a></div>' + variant + plan +
      '<div class="stepper">' +
        '<button type="button" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Minder">–</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Meer">+</button>' +
      '</div>' + labels(item) + '</div>' +
      '<div class="right"><span class="pr">' + money(item.final_line_price) + '</span>' + old +
      '<button type="button" class="rm" data-key="' + item.key + '" data-qty="0">Verwijderen</button></div></div>';
  }

  function render(open) {
    return fetchCart().then(function (cart) {
      var counts = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < counts.length; i++) {
        counts[i].textContent = cart.item_count;
        counts[i].classList.remove('bump');
        void counts[i].offsetWidth;
        counts[i].classList.add('bump');
      }
      var drawer = document.getElementById('drawer');
      if (!drawer) return cart;

      var head = document.getElementById('drCount');
      if (head) head.textContent = cart.item_count === 1 ? '1 artikel' : cart.item_count + ' artikelen';

      var ship = document.getElementById('ship');
      if (ship && FREE > 0) {
        var left = Math.max(0, FREE - cart.total_price);
        ship.classList.toggle('done', left === 0);
        document.getElementById('shipBar').style.width = Math.min(100, (cart.total_price / FREE) * 100) + '%';
        document.getElementById('shipMsg').innerHTML = left === 0
          ? 'Gratis verzending — <b>geregeld</b>'
          : 'Nog <b>' + money(left) + '</b> tot gratis verzending';
      }

      var lines = document.getElementById('lines');
      lines.innerHTML = cart.items.length
        ? cart.items.map(lineHtml).join('')
        : '<div class="empty"><div class="t">Nog leeg</div><p>Nog niets in je winkelwagen.</p>' +
          '<a class="btn btn-chrome" href="/collections/all">Bekijk de producten</a></div>';

      var save = cart.total_discount
        ? '<div class="save"><span>Korting</span><span>- ' + money(cart.total_discount) + '</span></div>' : '';
      document.getElementById('foot').innerHTML = cart.items.length
        ? '<div class="sums"><div><span>Subtotaal</span><span>' + money(cart.items_subtotal_price) + '</span></div>' + save +
          '<div><span>Verzending</span><span>' + (FREE > 0 && cart.total_price >= FREE ? 'Gratis' : 'Berekend bij afrekenen') + '</span></div>' +
          '<div class="tot"><span>Totaal incl. btw</span><b>' + money(cart.total_price) + '</b></div></div>' +
          '<form action="/cart" method="post"><button type="submit" name="checkout" class="btn btn-chrome">Afrekenen · ' + money(cart.total_price) + '</button></form>' +
          '<div class="pay"><span>iDEAL</span><span>Bancontact</span><span>Visa</span><span>Mastercard</span><span>PayPal</span></div>' +
          '<button type="button" class="keep" data-close-cart>Verder winkelen</button>'
        : '<div class="pay"><span>iDEAL</span><span>Bancontact</span><span>Visa</span><span>Mastercard</span><span>PayPal</span></div>';

      var extras = document.getElementById('extras');
      if (extras) extras.style.display = cart.items.length ? 'block' : 'none';

      var up = document.getElementById('upBox');
      if (up) {
        var ids = cart.items.map(function (i) { return i.product_id; });
        var cards = up.querySelectorAll('[data-up-product]');
        var shown = 0;
        for (var j = 0; j < cards.length; j++) {
          var hide = ids.indexOf(parseInt(cards[j].getAttribute('data-up-product'), 10)) > -1;
          cards[j].style.display = hide ? 'none' : 'flex';
          if (!hide) shown++;
        }
        up.style.display = shown && cart.items.length ? 'block' : 'none';
      }

      // Andere blokken in de lade (levertijd, vertrouwensbalk, aanbod) hangen hieraan.
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));

      if (open) window.openCart();
      return cart;
    });
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest ? e.target.closest('[data-key]') : null;
    if (step) { e.preventDefault(); window.cartChange(step.getAttribute('data-key'), parseInt(step.getAttribute('data-qty'), 10)); return; }
    if (e.target.closest('[data-close-cart]')) { e.preventDefault(); window.closeCart(); return; }
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); render(true); return; }
    var up = e.target.closest('[data-add-variant]');
    if (up) {
      e.preventDefault(); up.disabled = true;
      window.cartAdd(up.getAttribute('data-add-variant'), 1).then(function () { up.disabled = false; });
    }
  });

  window.applyCode = function () {
    var v = document.getElementById('code').value.trim();
    var m = document.getElementById('codeMsg');
    if (!v) { m.className = 'codeMsg bad'; m.textContent = 'Vul een code in'; return; }
    window.location.href = '/discount/' + encodeURIComponent(v) + '?redirect=/cart';
  };

  function initProduct() {
    var form = document.querySelector('[data-product-form]');
    var json = document.getElementById('product-json');
    if (!form || !json) return;
    var data = JSON.parse(json.textContent);
    var state = { qty: 1 };
    state.variant = data.variants.filter(function (v) { return v.id === data.selected; })[0] || data.variants[0];

    function paint() {
      var v = state.variant, price = v.price, compare = v.compare_at_price;
      var planNode = form.querySelector('[data-plan][aria-pressed="true"]');
      var planId = planNode ? planNode.getAttribute('data-plan') : '';
      state.plan = planId || null;
      if (planId) {
        var alloc = (v.selling_plan_allocations || []).filter(function (a) { return String(a.selling_plan_id) === String(planId); })[0];
        if (alloc) { price = alloc.price; compare = v.price; }
      }
      form.querySelector('[data-price]').textContent = money(price);
      form.querySelector('[data-was]').textContent = compare && compare > price ? money(compare) : '';
      form.querySelector('[name="id"]').value = v.id;
      var planInput = form.querySelector('[name="selling_plan"]');
      if (planInput) planInput.value = planId || '';
      var btn = form.querySelector('[data-add]');
      btn.disabled = !v.available;
      btn.textContent = v.available
        ? (planId ? 'Abonnement starten · ' : 'In winkelwagen · ') + money(price * state.qty)
        : 'Uitverkocht';
      var dot = form.querySelector('[data-dot]');
      if (dot) dot.classList.toggle('off', !v.available);
      // Afsluittijd 16:00 op werkdagen. Staat ook in snippets/crafd-levertijd.liquid,
      // snippets/verzendblok.liquid, sections/main-product.liquid en templates/index.json.
      var stock = form.querySelector('[data-stock]');
      if (stock) stock.textContent = v.available
        ? 'Op voorraad — voor 16:00 besteld op werkdagen, dezelfde dag verzonden'
        : 'Tijdelijk uitverkocht';
      var st = document.querySelector('[data-sticky-price]');
      if (st) st.textContent = money(price) + (v.title && v.title !== 'Default Title' ? ' · ' + v.title : '');
    }

    form.querySelectorAll('[data-variant]').forEach(function (b) {
      b.addEventListener('click', function () {
        form.querySelectorAll('[data-variant]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        state.variant = data.variants.filter(function (v) { return String(v.id) === b.getAttribute('data-variant'); })[0];
        paint();
      });
    });
    form.querySelectorAll('[data-plan]').forEach(function (b) {
      b.addEventListener('click', function () {
        form.querySelectorAll('[data-plan]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        paint();
      });
    });
    var qtyInput = form.querySelector('[name="quantity"]');
    form.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.qty = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
        qtyInput.value = state.qty; paint();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      state.qty = Math.max(1, parseInt(qtyInput.value, 10) || 1); qtyInput.value = state.qty; paint();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add]');
      btn.disabled = true;
      window.cartAdd(state.variant.id, state.qty, state.plan).then(function () { btn.disabled = false; paint(); });
    });
    document.querySelectorAll('[data-sticky-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        window.cartAdd(state.variant.id, state.qty, state.plan);
      });
    });
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var stage = document.querySelector('[data-stage] img');
        if (stage) stage.src = t.getAttribute('data-thumb');
        document.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-selected', x === t); });
      });
    });
    paint();
  }

  function initSort() {
    var sel = document.querySelector('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      window.location.href = u.toString();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProduct(); initSort(); render(false);
  });
})();
